import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Inputs } from '@bagonboard/ui-kit';

import withStyles from '@material-ui/core/styles/withStyles';

import {
  Container, EditButton, HoverText, Text, style,
} from './style';

const { Address } = Inputs;

class EditAddress extends Component {
  state = {
    active: false,
    hover : false,
  };

  onClick = () => {
    this.setState({ active: true });
  };

  onInputBlur = (value) => {
    const { onChange } = this.props;
    onChange(value);
    this.setState({ active: false, hover: false });
  };

  onMouseEnter = () => {
    this.setState({ hover: true });
  };

  onMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const {
      area, children, classes, value, editable, location,
    } = this.props;
    const { active, hover } = this.state;

    return (
      <Container>
        {editable && active && (
          <Address
            area={area}
            classes={{
              container: classes.container,
              icon     : classes.icon,
              input    : classes.input,
              label    : classes.label,
            }}
            coverage={[]}
            handleBlur={this.onInputBlur}
            location={location}
            value={value}
          />
        )}
        {editable && !active && (
          <HoverText
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
          >
            {children}
            {hover && <EditButton onClick={this.onClick} />}
          </HoverText>
        )}
        {!editable && (
          <Text>{children}</Text>
        )}
      </Container>
    );
  }
}
EditAddress.propTypes = {
  area    : PropTypes.string,
  classes : PropTypes.shape({}).isRequired,
  children: PropTypes.node,
  editable: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
  value   : PropTypes.string,
  onChange: PropTypes.func,
};
EditAddress.defaultProps = {
  area    : 'MAD',
  children: null,
  editable: true,
  value   : null,
  onChange() {},
};

export default withStyles(style)(EditAddress);
